// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19uvq","col":"styles_col__1Nw0_"};